// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loading_loaderContainer__oOA-5","loader":"Loading_loader__kJ8a+","spinner-rotation":"Loading_spinner-rotation__M8oiU","errorMessage":"Loading_errorMessage__doiKV"};